module.exports = __webpack_public_path__ + "static/media/polyfill.20d5578d.mjs";